/**
 * `<ArticleImage>` — drop-in <img> replacement that gracefully falls back to a
 * topic-relevant placeholder when the original URL fails to load (e.g. an
 * Unsplash photo ID is retired). Used by the Knowledge Hub grid and article
 * detail pages so dead image URLs never render a broken-image icon.
 */
import { useState } from "react";

// Generic water-themed fallback — pre-verified live. The same URL is used as
// the ultimate fallback if the article's specific cover is unreachable.
const FALLBACK_URL =
  "https://images.unsplash.com/photo-1548946526-f69e2424cf45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export function ArticleImage({ src, alt, className = "" }) {
  const [errored, setErrored] = useState(false);
  const finalSrc = errored || !src ? FALLBACK_URL : src;
  return (
    <img
      src={finalSrc}
      alt={alt || "Aware Water Testing article"}
      loading="lazy"
      className={className}
      onError={() => { if (!errored) setErrored(true); }}
    />
  );
}

export default ArticleImage;
